export const data = [
  {
    image: require("../assets/images/games/piko.png"),
    name: "Experimental - Piko",
    googlePlayUrl: "https://play.google.com/store/apps/details?id=com.latifyilmaz.Experimental",
    pcUrl: ""
  },
  {
    image: require("../assets/images/games/gyra.png"),
    name: "GYRA",
    googlePlayUrl: "https://play.google.com/store/apps/details?id=com.latifyilmaz.GYRA",
    pcUrl: ""
  },
  {
    image: require("../assets/images/games/toyworld.png"),
    name: "Toy World",
    googlePlayUrl: "https://play.google.com/store/apps/details?id=com.latifyilmaz.ToyWorld",
    pcUrl: "https://lativegames.itch.io/toy-world"
  },
  {
    image: require("../assets/images/games/thatdamnbirds.png"),
    name: "That Damn Birds",
    googlePlayUrl: "",
    pcUrl: "https://lativegames.itch.io/that-damn-birds"
  },
  {
    image: require("../assets/images/games/question-exclamation.png"),
    name: "?!",
    googlePlayUrl: "",
    pcUrl: "https://lativegames.itch.io/question-exclamation"
  },
  {
    image: require("../assets/images/games/gotta-eat-everything.png"),
    name: "Gotta Eat Everything",
    googlePlayUrl: "",
    pcUrl: "https://lativegames.itch.io/gotta-eat-everything"
  },
  {
    image: require("../assets/images/games/atoms-lie.png"),
    name: "Atom's Lie",
    googlePlayUrl: "",
    pcUrl: "https://lativegames.itch.io/atoms-lie"
  },
  {
    image: require("../assets/images/games/mad-bad.png"),
    name: "Mad Bad!",
    googlePlayUrl: "",
    pcUrl: "https://lativegames.itch.io/mad-bad"
  },
  {
    image: require("../assets/images/games/locus.png"),
    name: "Locus",
    googlePlayUrl: "",
    pcUrl: "https://lativegames.itch.io/locus"
  },
  {
    image: require("../assets/images/games/solar-sandbox.png"),
    name: "Solar Sandbox",
    googlePlayUrl: "",
    pcUrl: "https://lativegames.itch.io/solar-sandbox"
  },
]